import React from "react";

function PartnerTag() {
  return <div className="partner-tag-container">Partner</div>;
}

export default PartnerTag;
